import api from './api';
import { STORAGE_KEYS } from '../utils/constants';

export const authService = {
  // Register new user
  register: async userData => {
    const response = await api.post('/auth/register', userData);
    const responseData = response.data?.data || response.data;
    const { token, user } = responseData;

    if (token && user) {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    }

    return { token, user };
  },

  // Login user
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    const responseData = response.data?.data || response.data;
    const { token, user } = responseData;

    if (token && user) {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    }

    return { token, user };
  },

  // Logout user
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Logout error handled silently
    } finally {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
    }
  },

  // Get current user info from API
  getMe: async () => {
    const response = await api.get('/auth/me');
    // Backend returns: { success: true, data: { user: {...} } }
    // So response.data.data is { user: {...} }, we need to extract user
    const data = response.data?.data || response.data;
    const user = data?.user || data;

    // Update stored user info
    if (user) {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    }

    return user;
  },

  // Get current user from storage
  getCurrentUser: () => {
    const userStr = localStorage.getItem(STORAGE_KEYS.USER);
    return userStr ? JSON.parse(userStr) : null;
  },

  // Get token from storage
  getToken: () => {
    return localStorage.getItem(STORAGE_KEYS.TOKEN);
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem(STORAGE_KEYS.TOKEN);
  },
};
